import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { RHFTextField } from '../../RHF';
import { UserInfoFormData } from '../validationSchemas';

interface UserInfoFormProps {
  formMethods: any; // FormProvider methods
  isPending: boolean;
  onSubmit: (data: UserInfoFormData) => void;
}

const UserInfoForm: React.FC<UserInfoFormProps> = ({
  formMethods,
  isPending,
  onSubmit,
}) => {
  const chatSupportFieldSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '12px',
      },
    },
  };

  return (
    <Box className="chat-support__body">
      <Box className="chat-support__intro">
        <Typography component="h4" className="chat-support__intro-title">
          We just need a couple of details
        </Typography>
        <Typography component="p" className="chat-support__intro-text">
          Share your info so we can open a session and loop in the right teammate.
        </Typography>
      </Box>

      <FormProvider {...formMethods}>
        <form
          onSubmit={formMethods.handleSubmit(onSubmit)}
          className="chat-support__user-form"
          noValidate
        >
          <Box className="chat-support__field">
            <Typography
              component="label"
              htmlFor="chatSupportName"
              className="chat-support__label"
            >
              Full Name
            </Typography>
            <RHFTextField
              id="chatSupportName"
              name="customer_name"
              placeholder="Your name"
              className="chat-support__input"
              sx={chatSupportFieldSx}
            />
          </Box>

          <Box className="chat-support__field">
            <Typography
              component="label"
              htmlFor="chatSupportEmail"
              className="chat-support__label"
            >
              Email Address
            </Typography>
            <RHFTextField
              id="chatSupportEmail"
              name="customer_email"
              type="email"
              placeholder="you@example.com"
              className="chat-support__input"
              sx={chatSupportFieldSx}
            />
          </Box>
          <Button
            type="submit"
            variant="contained"
            fullWidth
            className="chat-support__primary-btn"
            disabled={isPending}
          >
            {isPending ? 'Starting...' : 'Start chat'}
          </Button>
        </form>
      </FormProvider>
    </Box>
  );
};

export default UserInfoForm;
